module.exports = __webpack_public_path__ + "img/IMG_2480.45f4f839.jpg";